import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, emailNote } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader, Section, Field, ErrorBox } from "@/components/Common";
import { ChangePassword } from "@/components/ChangePassword";

export default function Profile() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: user.name, phone: user.phone });
  const [err, setErr] = useState(null);
  const save = async (e) => {
    e.preventDefault();
    setErr(null);
    try { const r = await api.put("/customer/profile", f); setUser(r.data); toast.success("Your details have been updated"); } catch (e2) { setErr(errMsg(e2)); }
  };
  const removeAddr = async (id) => {
    try { await api.delete(`/customer/profile/addresses/${id}`); setUser({ ...user, addresses: user.addresses.filter((a) => a.id !== id) }); toast.success("Address removed"); } catch (e) { toast.error(errMsg(e)); }
  };
  const deletion = async () => {
    if (!window.confirm("Send a request to DJ Landscapes to delete your personal data?")) return;
    try { const r = await api.post("/customer/profile/deletion-request"); toast.success(`Deletion request recorded. ${emailNote(r.data.email_status)}`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mx-auto max-w-2xl space-y-5">
      <PageHeader title="Your profile" />
      <Section title="Contact details">
        <form onSubmit={save} className="grid gap-4">
          <ErrorBox error={err} />
          <Field label="Full name" id="pn"><Input id="pn" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="profile-name-input" /></Field>
          <Field label="Email address" id="pe" hint="Contact DJ Landscapes to change your sign-in email."><Input id="pe" value={user.email} disabled data-testid="profile-email" /></Field>
          <Field label="Telephone" id="pp"><Input id="pp" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="profile-phone-input" /></Field>
          <Button type="submit" className="w-fit" data-testid="profile-save-btn">Save changes</Button>
        </form>
      </Section>
      <Section title="Saved property addresses">
        {!user.addresses?.length ? <p className="text-sm text-muted-foreground">Addresses are saved when you submit a job request.</p> : user.addresses.map((a) => (
          <div key={a.id} className="mb-2 flex items-center justify-between rounded-md border border-border p-3 text-sm">
            <span>{a.address}, {a.postcode}</span><Button size="sm" variant="ghost" onClick={() => removeAddr(a.id)} data-testid="address-remove-btn">Remove</Button>
          </div>))}
      </Section>
      <ChangePassword />
      <Section title="Your data">
        <p className="mb-3 text-sm text-muted-foreground">You can ask DJ Landscapes to delete your personal data. Records required for legal or accounting purposes may be retained as set out in the privacy information.</p>
        <Button variant="outline" onClick={deletion} data-testid="deletion-request-btn">Request data deletion</Button>
      </Section>
    </div>
  );
}
